<template>
  <GoogleLogin class="google-btn" :client-id="googleClientId" :callback="handleGoogleLogin"/>
</template>

<script>
import {GoogleLogin} from "vue3-google-login";
import {useAuthUserStore} from "@/stores/modules/auth.module";
import PromptIndividualOrBusiness from "@/components/auth/PromptIndividualOrBusiness.vue";
import {useNotificationStore} from "@/stores/notification.module";
import CompanyInfoForm from "@/components/auth/CompanyInfoForm.vue";
import {company} from "@/models/auth/businessUserRegister";

export default {
  name: 'GoogleLoginBtn',
  setup() {
    const authStore = useAuthUserStore();
    const notificationStore = useNotificationStore();
    return {
      authStore,
      notificationStore
    }
  },
  emits:['registration-required'],
  components: {CompanyInfoForm, PromptIndividualOrBusiness, GoogleLogin},
  computed:{
  },
  data(){
    return {
      loading:false,
      googleToken:null,
      addCompany:false,
      companyRequest: new company(),
      googleClientId: '168776721506-mvsbqdbldpq2f2p1d7lpou260iv10ert.apps.googleusercontent.com',
      options:[
        {text:'private',value:'individual'},
        {text:'business',value:'business'}
      ],
    }
  },
  methods: {
    async handleGoogleLogin(response) {
      const googleToken = response.credential;
      console.log("Google token: ",googleToken);
      console.log("Google response: ",response);
      // Send token to your backend
       const data = await this.authStore.loginSocials('google', {
         token: googleToken
       });
       if(data.requires_registration_completion){
         this.$emit('registration-required',{token:googleToken});
         console.log("Required Registration: ",data);
       }
        console.log("Google login: ",data);
    }
  }
}
</script>
<style>
.google-btn iframe{
  width:100%!important;
  margin:0 auto!important;
}
</style>